import { render } from "./NewPixKeyForm.vue?vue&type=template&id=2034b9b2"
import script from "./NewPixKeyForm.vue?vue&type=script&lang=js"
export * from "./NewPixKeyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__